// extracted by mini-css-extract-plugin
export default {"feed_detail":"feed-detail_feed_detail__sIO2T","container":"feed-detail_container__DNqKC","price":"feed-detail_price__9x-1N","footer":"feed-detail_footer__Sqo8R"};